import React, { useState, useEffect } from "react";
import { IoClose } from "react-icons/io5";
import "./CreateListPopup.scss";
import { toast } from "react-hot-toast";

const CreateListPopup = ({ isOpen, onClose, onSave, listToEdit }) => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    sharing: "private",
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (listToEdit) {
      setFormData({
        name: listToEdit.name || "",
        description: listToEdit.description || "",
        sharing: listToEdit.sharing || "private",
      });
    } else {
      setFormData({
        name: "",
        description: "",
        sharing: "private",
      });
    }
  }, [listToEdit, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSaving(true);
      await onSave(formData);
      onClose();
    } catch (error) {
      console.error("Error saving list:", error);
      toast.error("An error occurred while saving the list");
    } finally {
      setSaving(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="createListPopup">
      <div className="popupContent">
        <div className="popupHeader">
          <h2>{listToEdit ? "Edit List" : "Create New List"}</h2>
          <button className="closeBtn" onClick={onClose} disabled={saving}>
            <IoClose />
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="formGroup">
            <label htmlFor="name">List Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Enter list name"
              disabled={saving}
            />
          </div>
          <div className="formGroup">
            <label htmlFor="description">Description</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Enter list description"
              rows={4}
              disabled={saving}
            />
          </div>
          <div className="formGroup">
            <label htmlFor="sharing">Sharing</label>
            <select
              id="sharing"
              name="sharing"
              value={formData.sharing}
              onChange={handleChange}
              disabled={saving}
            >
              <option value="private">Private</option>
              <option value="public">Public</option>
              <option value="team">Team</option>
            </select>
          </div>
          <div className="formActions">
            <button 
              type="button" 
              className="cancelBtn" 
              onClick={onClose}
              disabled={saving}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="saveBtn"
              disabled={saving}
            >
              {saving ? (
                <>
                  <span className="button-loader"></span>
                  {listToEdit ? "Updating..." : "Creating..."}
                </>
              ) : (
                listToEdit ? "Update" : "Create"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateListPopup; 